<template>
<section class="company-basic">
	<div class="w companyInfo_box">
		<div class="companyInfo_boxL">
			{{ companyData.shopIntroduce }}
		</div>
		<el-image :src="companyData.shopBackground || displayImg" fit="cover"></el-image>
	</div>
	<div class="w companyInfo_boxBottom">
		<div class="companyInfo_boxBottomL">
			<div>
				<div class="companyInfo_boxBottomLBox">
					<el-image style="width: 70px; height: 70px;" fit="cover"
						:src="companyInfoBottomIcon"></el-image>
				</div>
				<div style="font-size: 14px;color: #aaa;">服务过程全监督</div>
			</div>
			<div>
				<div class="companyInfo_boxBottomLBox">
					<el-image style="width: 70px; height: 70px;" fit="cover"
						:src="companyInfoBottomIcon"></el-image>
				</div>
				<div style="font-size: 14px;color: #aaa;">交易问题退款维权</div>
			</div>
			<div>
				<div class="companyInfo_boxBottomLBox">
					<el-image style="width: 70px; height: 70px;" fit="cover"
						:src="companyInfoBottomIcon"></el-image>
				</div>
				<div style="font-size: 14px;color: #aaa;">服务商实名验证</div>
			</div>
		</div>
		<div class="middleLine"></div>
		<div class="companyInfo_boxBottomM">
			<i class="el-icon-warning-outline" style="color:#000;"></i>
			<span>云市场免费提供线上担保交易、全程服务监督，保障您的资金安全和服务质量，90%的欺诈、纠纷、资金盗取均由线下交易导致，请勿线下交易！</span>
		</div>
		<div class="middleLine"></div>
		<div class="companyInfo_boxBottomR">
			<div style="margin-bottom:10px;">
				<i class="el-icon-s-shop" style="color:#000;margin-right:10px;"></i>
				<span style="margin-right:20px;">供应商:</span>
				<span>{{ supplierData.name }}</span>
			</div>
			<div style="margin-bottom:10px;">
				<i class="el-icon-phone" style="color:#000;margin-right:10px;"></i>
				<span style="margin-right:20px;">客服电话:</span>
				<span>{{ companyData.serviceHotline }}(工作日{{ companyData.serviceBeginTime ?
					companyData.serviceBeginTime.substring(0, 5) : '' }}-
					{{ companyData.serviceEndTime ? companyData.serviceEndTime.substring(0, 5) : '' }})</span>
			</div>
			<div style="margin-bottom:10px;">
				<i class="el-icon-s-promotion" style="color:#000;margin-right:10px;"></i>
				<span style="margin-right:20px;">通讯邮箱:</span>
				<span>{{ companyData.shopEmail }}</span>
			</div>
		</div>
	</div>
</section>
</template>

<script>
import displayImg from '../../assets/imgs/RemoteSensingMall/shop/shop-display.png'
export default {
	props: {
		companyData: {
			type: Object,
			default: {}
		},
		supplierData: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			displayImg,
			companyInfoBottomIcon: require("@/assets/imgs/RemoteSensingMall/companyInfoBottomIcon.svg"),
		}
	}
}
</script>

<style lang="scss" scoped>
.company-basic {
	
	> .companyInfo_box {
		padding: 20px 0;
		display: flex;
		justify-content: space-between;
		gap: 32px;
		
		> .companyInfo_boxL {
			flex: 1;
			font-size: 18px;
			line-height: 30px;
		}
		> .el-image {
			flex: 1;
			min-height: 320px;
			max-height: 420px;
			border-radius: 12px;
		}
	}
	> .companyInfo_boxBottom {
		display: flex;
		align-items: center;
		padding: 20px;
		background: #fafbfb;

		> .companyInfo_boxBottomL {
			width: 30%;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.companyInfo_boxBottomLBox {
				position: relative;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}
		}
		> .middleLine {
			width: 2px;
			height: 40px;
			background: #ccc;
			margin: 0 50px;
		}
		> .companyInfo_boxBottomM {
			width: 30%;
			font-size: 14px;
			color: #aaa;
		}
		> .companyInfo_boxBottomR {
			width: 30%;
			font-size: 14px;
			color: #aaa;
		}
	}
}
</style>